<template>
  <!-- App Header -->
  <SideHeader :indexPage="true" />

  <!-- * App Header -->

  <!-- Extra Header -->
  <div class="extraHeader">
    <ul class="nav nav-tabs lined" role="tablist">
      <li class="nav-item">
        <a class="nav-link active" data-bs-toggle="tab" href="#ticket" role="tab">
          تیکت
        </a>
      </li>
      <li class="nav-item">
        <a @click="getMessages(postData.mobileNumber)" class="nav-link" data-bs-toggle="tab" href="#archive" role="tab">
          بایگانی
        </a>
      </li>
    </ul>
  </div>
  <!-- * Extra Header -->

  <!-- App Capsule -->
  <div id="appCapsule" class="extra-header-active">

    <div class="tab-content mt-1">
      <!-- ticket tab -->
      <div class="tab-pane fade show active" id="ticket" role="tabpanel">

        <div class="section full mt-1">
          <div class="section-title">تیکت پشتیبانی</div>

          <div class="wide-block pt-2 pb-2">

            <div class="tab-content mt-2">
              <form>
                <div class="form-group basic">
                  <div class="input-wrapper">
                    <label class="form-label" for="title">عنوان</label>
                    <input type="text" class="form-control" name="title" id="title" v-model="postData.title" />
                    <i class="clear-input">
                      <ion-icon name="close-circle" role="img" class="md hydrated" aria-label="close circle"></ion-icon>
                    </i>
                  </div>
                </div>
                <div class="form-group basic">
                  <div class="input-wrapper">
                    <label class="form-label" for="description">توضیحات</label>
                    <textarea id="description" name="description" rows="2" class="form-control"
                      v-model="postData.message"></textarea>
                    <i class="clear-input">
                      <ion-icon name="close-circle" role="img" class="md hydrated" aria-label="close circle"></ion-icon>
                    </i>
                  </div>
                </div>
                <div class="mt-2">
                  <button class="btn background-ORANGE text-light btn-block btn-block" @click.prevent="createPost"
                    type="submit">
                    ارسال
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- * ticket tab -->



      <!-- archive tab -->
      <div class="tab-pane fade" id="archive" role="tabpanel">

        <div class="section full mt-1">
          <div class="section-title">پیام های بایگانی شده</div>
          <div class="wide-block pb-2">
            <div class="tab-content mt-2">
              <div class="tab-pane fade show active" role="tabpanel">
                <Placeholder v-if="loading" />

                <div v-else v-for="(item, index) in messages" :key="index" class="section my-2">
                  <div class="card" v-if="messages != ''">
                    <div class="card-header">
                      {{ item.title }}
                    </div>
                    <div class="card-body">
                      <p class="card-text">
                        {{ item.message }}
                      </p>
                    </div>
                  </div>
                </div>
                <p class="text-center" v-if="messages == ''">پیام یافت نشد</p>
              </div>

            </div>

          </div>
        </div>
      </div>
      <!-- * archive tab -->
    </div>
  </div>
  <!-- * App Capsule -->
</template>

<script>
import axios from "axios";
import delivery_methods from "@/delivery_methods";
import Swal from "sweetalert2";
import Placeholder from "@/components/Placeholder.vue";
import SideHeader from "@/components/SideHeader.vue";
// import Swal from "sweetalert2";
export default {
  name: "Support",
  data() {
    return {
      postData: {
        role: "driver",
        name: "",
        lastName: "",
        message: "",
        mobileNumber: "",
        email: "driver.gmail.com",
      },
      loading: false,
      messages: [],
      idUser: window.localStorage.getItem("idUser"),
    };
  },
  methods: {
    getInitialCargos() {
      axios
        .get(`${delivery_methods.BASE_URL}api/driver/getDriverProfileInfo/${this.idUser}`)
        .then((response) => {
          this.postData.name = response.data.data.name;
          this.postData.lastName = response.data.data.lastName;
          this.postData.mobileNumber = response.data.data.mobileNumber;
          // this.getMessages(this.postData.mobileNumber);
        })
        .catch(function (res) {
          // handle error
          console.log(res);
        });
    },
    getMessages(mobileNumber) {
      this.loading = true
      axios.get(`${delivery_methods.BASE_URL}api/driver/driverMessages/${mobileNumber}`)
        .then((response) => {
          this.messages = response.data;
        })
        .catch(function (res) {
          // handle error 
          // console.log(res);
        })
        .finally((res) =>{
          this.loading = false
        });
    },
    createPost() {
      axios
        .post(`https://dashboard.iran-tarabar.ir/api/driver/sendMessage`, this.postData)
        .then((response) => {
          if (response.data.result == 1) {
            Swal.fire({
              title: `با تشکر از شما`,
              text: "پیام شما برای تیم پشتیبانی ارسال شد!",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "حله",
            }).then((result) => {
              if (result.isConfirmed) {
                location.reload();
              }
            });
          }
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    },
  },
  beforeMount() {
    this.getInitialCargos();
  },
  mounted() {
    // this.getMessages();
  },
  components: { Placeholder,SideHeader }
};
</script>

<style scoped></style>